<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <Breadcrumb :items="breadcrumbItems" />
      <section
        style="
          background-color: var(--white);
          box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
          border-radius: 12px;
          padding: 24px 24px;
          margin-top: 32px;
          width: 100%;
        "
        class="d-flex flex-column justify-content-between"
      >
        <section class="row">
          <div class="d-flex w-100 session-one responsive">
            <div
              class="col-lg-12 col-12 card-styling justify-content-between d-flex flex-column"
              style="padding: 0"
            >
              <div class="col-12">

                <div
                  v-if="!isPending"
                  class="d-flex session-one"
                  style="justify-content: center"
                >
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-coracao.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Curtidas
                    </p>
                    <h2 class="text-center h2-card">
                      {{ item.likeCount }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Comentários</p>
                    <h2 class="text-center h2-card">
                      {{ item.commentsCount }}
                    </h2>
                  </div>
                  <div
                    v-if="item.mediaProductType !== 'STORY'"
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-salvar.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Salvos
                    </p>
                    <h2 class="text-center h2-card">
                      {{ item.savedCount }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-share.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Compartilhamento
                    </p>
                    <h2 class="text-center h2-card">
                      {{ item.sharesCount }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Alcance</p>
                    <h2 class="text-center h2-card">
                      {{ item.reachCount }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Impressões</p>
                    <h2 class="text-center h2-card">
                      {{ item.impressionsCount }}
                    </h2>
                  </div>
                </div>

                <div
                  v-else
                  class="d-flex session-one"
                  style="justify-content: center"
                >
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Status</p>
                    <h2 class="text-center h2-card" style="font-size: 28px">
                      {{ translateStatus(item.publishStatus) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Usuário</p>
                    <h2 class="text-center h2-card" style="font-size: 18px">
                      {{ item.username || "-" }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Usuário do Facebook</p>
                    <h2 class="text-center h2-card" style="font-size: 18px">
                      {{ item.facebookUserName || "-" }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Tipo</p>
                    <h2 class="text-center h2-card" style="font-size: 28px">
                      {{
                        item.mediaType == "IMAGE"
                          ? "Imagem"
                          : item.mediaType == "VIDEO"
                          ? "Vídeo"
                          : item.mediaType == "CAROUSEL_ALBUM"
                          ? "Carrossel"
                          : "-"
                      }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr style="border-color: #d3e7fb; width: 100%" />
        <section>
          <div class="session-one" style="display: flex; width: 100%">
            <img
              v-if="item.mediaType === 'IMAGE'"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 400px;
                width: 400px;
              "
              :src="item.mediaUrl"
              class="img-fluid d-block w-100 img-responsivo"
              alt=""
            />

            <div
              v-if="item.mediaType == 'CAROUSEL_ALBUM'"
              id="carouselExampleControls"
              class="carousel slide"
              data-bs-interval="false"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 400px;
                width: 400px;
              "
            >
              <div class="carousel-inner">
                <div
                  v-for="(photos, index) in item.instagramMediaContainers"
                  :key="photos.id"
                  class="carousel-item"
                  :class="index === 0 ? 'active' : ''"
                >
                  <img
                    :src="photos.mediaUrl"
                    class="img-fluid d-block w-100 img-responsivo"
                    alt=""
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>

            <video
              v-if="item.mediaType == 'VIDEO'"
              :src="item.mediaUrl"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 400px;
                width: 400px;
              "
            ></video>
            <div style="margin-left: 32px">
              <section
                class="d-flex flex-column justify-content-between align-items-start w-100"
              >
                <h4
                  style="
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    color: #80848a;
                  "
                >
                  Publicação
                </h4>

                <div
                  class="d-flex justify-content-between align-items-center w-100 col-md-12"
                >
                  <div
                    class="d-flex justify-content-between align-items-center col-md-8"
                  >
                    <span class="d-flex justify-content-between flex-column">
                      <p
                        style="
                          font-style: normal;
                          font-weight: 400;
                          font-size: 14px;
                          color: #80848a;
                          margin: 0;
                        "
                      >
                        Loja
                      </p>
                      <p
                        style="
                          font-style: normal;
                          font-weight: 500;
                          font-size: 16px;
                          color: #383838;
                          margin: 0;
                        "
                      >
                        {{ item.instagramPage?.pageName }}
                      </p>
                      <!-- Links abaixo do nome da loja -->
                      <div class="d-flex" style="gap: 12px; margin-top: 4px">
                        <a
                          :href="item.instagramPage?.instaPageLink || '#'"
                          target="_blank"
                          class="detail-link"
                        >Página do Instagram</a>
                        <a
                          :href="item.permalink || '#'"
                          target="_blank"
                          class="detail-link"
                        >Link da Postagem</a>
                      </div>
                    </span>
                  </div>
                  <span style="margin-left: 10%">
                    <p
                      style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        color: #80848a;
                        margin: 0;
                      "
                    >
                      Data
                    </p>
                    <p
                      style="
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        color: #383838;
                        margin: 0;
                      "
                    >
                      {{ currentDate(item.timestamp) }}
                    </p>
                  </span>
                  <span style="margin-left: 10%">
                    <p
                      style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        color: #80848a;
                        margin: 0;
                      "
                    >
                      Horário
                    </p>
                    <p
                      style="
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        color: #383838;
                        margin: 0;
                      "
                    >
                      {{ currentHorario(item.timestamp) }}
                    </p>
                  </span>
                </div>
              </section>
              <section style="margin-top: 10%">
                <h4
                  style="
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    color: #80848a;
                  "
                >
                  Descrição
                </h4>
                <span>
                  <p style="font-weight: 500; font-size: 16px; color: #383838">
                    {{ item.caption || "Sem legenda" }}
                  </p>
                </span>
              </section>

              <!-- Mensagem de Erro para Pendentes -->
              <section
                v-if="
                  isPending &&
                  item.publishStatus === 'ERROR' &&
                  item.errorMessage
                "
                style="margin-top: 32px"
              >
                <h4
                  style="
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    color: #80848a;
                    margin-bottom: 12px;
                  "
                >
                  Mensagem de Erro
                </h4>
                <div
                  style="
                    background-color: #fee;
                    border-left: 4px solid #f44;
                    padding: 14px 16px;
                    border-radius: 6px;
                    color: #c33;
                    font-size: 14px;
                    line-height: 1.6;
                  "
                >
                  {{ item.errorMessage }}
                </div>
              </section>
            </div>
          </div>
        </section>
        <div
          style="margin-top: 50px"
          v-if="!isPending && item.commentsCount > 1"
        >
          <h4
            style="
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              color: #80848a;
            "
          >
            Comentários
          </h4>
          <div
            class="col-12 mt-4"
            v-for="coments in comentarios"
            :key="coments.id"
            style="margin-top: 10px"
          >
            <div class="d-flex col-12">
              <div class="col-12 d-flex">
                <img
                  :src="require('@/assets/images/svg/avatar-default.svg')"
                  class="img-fluid"
                  style="max-width: 5%"
                  alt="imagem perfil"
                />
                <p class="p-comentario" style="margin-left: 10px">
                  <b style="color: black">{{ coments.instaUserName }}</b>
                  {{ coments.text }}
                </p>
              </div>
            </div>
            <div class="d-flex col-12">
              <div class="col-md-10 col-10">
                <p class="p-comentario" style="margin-left: 8%">
                  {{ currentDateTime(coments.timestamp) }}
                </p>
              </div>
              <div class="col-md-2 justify-content-end" v-if="!isReponder">
                <button
                  class="btn-card"
                  @click="
                    () => {
                      idComentario = coments.instaCommentId;
                    }
                  "
                  v-on:click="exibirOcultar(true)"
                >
                  Responder
                </button>
              </div>
            </div>
            <form
              @submit.prevent="submit()"
              v-if="idComentario == coments.instaCommentId"
            >
              <div class="col-md-12 col-12 d-flex mb-3" v-if="isReponder">
                <div class="col-md-1"></div>
                <div class="col-md-8">
                  <input
                    class="input-comentario"
                    placeholder="Escreva a sua resposta aqui"
                    type="text"
                    v-model="text"
                  />
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-2">
                  <button type="submit" class="btn-card">Enviar</button>
                </div>
              </div>
            </form>
            <div
              v-for="(item, index) in coments.replies"
              class="d-flex w-100"
              :key="index"
            >
              <div
                v-if="item != null"
                class="d-flex align-items-center p-3 rounded mt-1 w-50"
                style="background-color: #cfe2ff"
              >
                <div class="col-12 d-flex">
                  <img
                    :src="require('@/assets/images/svg/avatar-default.svg')"
                    class="img-fluid"
                    style="max-width: 5%"
                    alt="imagem perfil"
                  />
                  <div
                    class="p-comentario d-flex align-items-center"
                    style="margin-left: 10px"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 32px; gap: 16px"
        >
          <button
            v-if="isPending && ['ERROR', 'COMPLETED WITH ERRORS', 'ERROR_RETRY24', 'ERROR_RETRY1', 'ERROR(PUBLISHED)'].includes(item.publishStatus)"
            @click="retryPublish"
            class="btn"
            style="
              background-color: transparent;
              border: 2px solid var(--blue-medium);
              color: var(--blue-medium);
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              padding: 12px 48px;
              border-radius: 8px;
            "
          >
            Tentar Novamente
          </button>
          <button
            @click="
              isPending
                ? $router.push({ name: 'Posts', params: { tab: 'pendentes' } })
                : $router.push({ name: 'Posts' })
            "
            class="btn"
            style="
              background-color: var(--blue-medium);
              color: var(--white);
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              padding: 12px 48px;
              border-radius: 8px;
              border: none;
            "
          >
            {{ isPending ? "Voltar para Pendentes" : "Voltar para Postagens" }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment/moment";
import apiGerenciarMidiasService from "../service/apiGerenciarMidiasService";
import Loading from "vue-loading-overlay";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  components: { Loading, Breadcrumb },
  name: "Details",
  data() {
    return {
      isLoading: false,
      item: [],
      isReponder: false,
      slide: 0,
      text: "",
      idComentario: "",
      comentarios: [{ instaCommentId: "" }],
      isPending: false,
    };
  },
  computed: {
    breadcrumbItems() {
      return [
        { label: "Dashboard", route: { name: "Dashboard" } },
        { label: "Postagens", route: { name: "Posts" } },
        { label: "Detalhes", active: true },
      ];
    },
  },

  async created() {
    this.isLoading = true;
    this.isPending = this.$route.params.isPending || false;

    try {
      if (this.isPending && this.$route.params.pendingItem) {
        this.item = this.$route.params.pendingItem;
      } else {
        const response = await apiGerenciarMidiasService.getAllMedias({
          byId: true,
          instaMediaId: this.$route.params.id,
        });

        if (response.status === 200) {
          this.item = response.data.data[0];
        }
      }
    } catch (error) {
      // Handle error silently
    }

    if (!this.isPending) {
      this.getComentsDetails().then((res) => {
        this.comentarios = res.data.data;
      });
    }

    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },

  methods: {
    ...mapActions(["getDetails", "getComentsDetails", "PostComents"]),

    exibirOcultar(value) {
      this.isReponder = value;
    },

    currentDate(timestamp) {
      return moment(timestamp).format("DD/MM/YYYY");
    },
    currentHorario(timestamp) {
      return moment(timestamp).locale("pt-br").format("LT");
    },

    currentDateTime(timestamp) {
      return moment(timestamp).locale("pt-br").calendar();
    },
    pagination() {
      this.getComentsDetails({
        limit: true,
      }).then((res) => {
        this.comentarios = res.data.data;
      });
    },
    submit() {
      try {
        this.PostComents({
          commentId: this.idComentario,
          text: this.text,
        });
      } catch (error) {
        // Handle error silently
      }
    },
    translateStatus(status) {
      const statusMap = {
        WAITING: "Aguardando",
        PUBLISHED: "Publicado",
        ERROR: "Erro",
      };
      return statusMap[status] || status || "-";
    },
    async retryPublish() {
      this.isLoading = true;
      try {
        setTimeout(() => {
          this.$router.push({ name: "Posts", params: { tab: "pendentes" } });
        }, 500);
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.p-card {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.p-comentario {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.btn-card {
  color: #2485ea;
  border: none;
  border-radius: 8px;
  background: #d3e7fb;
  padding: 8px 25%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
}

.input-comentario {
  align-items: flex-start;
  padding: 12px 16px;
  background: #f0f2f8;
  border-radius: 4px;
  width: 100%;
  height: 43px;
  border: none;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #383838;
}

.detail-link {
  font-size: 13px;
  color: #2485ea;
  text-decoration: none;
}

.detail-link:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }

  .img-responsivo {
    max-width: 70%;
  }

  #section-security {
    margin: 12px 0 0 0;
  }

  #section-personal-data {
    margin: 0 0 12px 0;
  }
}

.h2-card {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
}
</style>
